import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { FormErrorMessages } from 'ecs-react-components/dist/index.es';
import { passwordMessages } from './PasswordValidation.i18n';

class PasswordField extends React.Component {
  getValidationMessage() {
    switch (this.props.field.input.name) {
      case 'newPwd':
        return this.props.intl.formatMessage(passwordMessages.error.password);
      case 'confirmNewPwd':
        return this.props.intl.formatMessage(passwordMessages.error.confirmPassword);
      default:
        break;
    }
    return null;
  }

  render() {
    const fieldClasses = classNames({
      'mb-3': true,
      'has-error': this.props.field.meta.invalid,
    });

    const inputClasses = classNames({
      'form-control': true,
      'no-label': true,
      'is-invalid': this.props.field.meta.invalid,
    })

    return (
    <div className={fieldClasses}>
      <input
        type="password"
        className={inputClasses}
        id={this.props.field.input.name}
        placeholder={ this.props.placeholder}
        value={ this.props.field.input.value || '' }
        onChange={ this.props.field.input.onChange}
        aria-label={ this.props.placeholder }
      />
      { this.props.field.meta.submitFailed ?
        <FormErrorMessages field={this.props.field}
          customMessage={this.getValidationMessage()}
        />
        : null}
      { this.props.children }
    </div>
    );
  }
}

PasswordField.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.object,
  placeholder: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(PasswordField);